/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { CieloMerchant } from '../../../core/_models'

type Props = {
    cieloMerchant: CieloMerchant,
}

const NameCell: FC<Props> = ({ cieloMerchant }) => {

    return <div className='d-flex align-items-center'>
        <div className='d-flex flex-column'>
            <span role='button' className="text-hover-danger">{cieloMerchant.name}</span>
        </div>
    </div>
}

export { NameCell }
